module.exports = __webpack_public_path__ + "static/media/shop-icon.50235039.svg";